






















import { ApiCreditcard } from '@/models/api/creditcard'
import ActionToPlanCreditcard from '@spa/components/pages/mypage/paid-membership/plans/ActionToPlanCreditcard.vue'
import { PlanGroupViewModel } from '@spa/components/pages/mypage/paid-membership/plans/models/plan-group'
import dateFormat from 'date-fns/format'
import { Option } from 'fp-ts/lib/Option'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ActionToPlanCreditcard,
  },
})
export default class NextPayment extends Vue {
  @Prop({ required: true })
  readonly group: PlanGroupViewModel

  @Prop({ required: true })
  creditcard: Option<ApiCreditcard>

  get nextPaymentPlan() {
    return this.group.nextPaymentPlan
  }

  /**
   * 解約済みの場合、その月は契約が有効だが翌月の支払いは存在しない
   */
  get formattedNextPayment(): string {
    if (!this.group.nextPayment) {
      return 'なし'
    }

    const date = dateFormat(this.group.nextPayment.next_payment.date, 'YYYY年MM月DD日')
    const price = this.group.nextPayment.next_payment.price
      .toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })

    return `${date} ${price}`
  }
}
